import { ICategorySoldProducts } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'

interface IIsEqualSelectedCategoryAndStaticCategory {
  selectedData: ICategorySoldProducts[]
  categoryKey: string
  staticData: ICategorySoldProducts[]
}

export const isEqualProductsCount = ({
  staticData,
  categoryKey,
  selectedData,
}: IIsEqualSelectedCategoryAndStaticCategory) => {
  const foundCategory = selectedData.find((el) => el.Key === categoryKey)
  const foundCategoryFromStaticData = staticData.find((el) => el.Key === categoryKey)
  if (foundCategoryFromStaticData && foundCategoryFromStaticData.Products.length === 0) {
    return Boolean(foundCategory) && Boolean(foundCategoryFromStaticData)
  }
  const foundProductsLength = foundCategory ? foundCategory.Products.length : 0
  const foundProductsFromStaticDataLength = foundCategoryFromStaticData
    ? foundCategoryFromStaticData.Products.length
    : 0

  return foundProductsLength === foundProductsFromStaticDataLength
}
